import Footer from "./Footer.blog";
import Header from "./Header.blog"
import { Outlet } from "react-router-dom";

const LayoutBlog = () => {


    return (
        <div className="blog-layout">
            <Header />

            {/* Contenido principal */}
            <main className="blog-content container-fluid animation">
                <Outlet />
            </main>

            <Footer />
        </div>
    )
}

export default LayoutBlog